//#region Libraries
import styled from "styled-components";
//#endregion

export const ListItemInactivity = styled.section`
    display: flex;
    flex-direction: column;
    gap: 5px;
    align-items: flex-start;
    & * {
        margin: 0;
    }
    & h3 {
        font-size: 16px;
        margin-bottom: 2px;
        color: var(--dark-1);
    }
    & h5 {
        font-size: 12px;
        color: var(--dark-4);
    }
    & h4 {
        font-size: 13px;
        color: var(--light-gray-5);
    }
    & span {
        margin-top: -8px;
    }
`;